/**
* Licensed Materials - Property of IBM
* IBM Watson Analytics (C) Copyright IBM Corp. 2017
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/

define([
	'../../lib/@waca/dashboard-common/dist/core/Model'
],

function(Class) {
	'use strict';

	// polyfill isNaN function for IE 11
	if (Number.isNaN === undefined) {
		Number.isNaN = function(x) {
			return x !== x;
		};
	}

	var RangeModel = Class.extend({
		whitelistAttrs: ['name', 'min', 'max', 'from', 'to', 'inverted'],

		init: function() {
			RangeModel.inherited('init', this, arguments);
			// defaults: I.e true if true... false otherwise
			let min, max, from, to;
			min = this._validate(this.min, 0, 'min');
			max = this._validate(this.max, 0, 'max');
			from = this._validate(this.from, min, 'from');
			to =  this._validate(this.to, max, 'to');

			this.set({
				inverted: Boolean(this.inverted),
				name: this.name || '',
				min: min,
				max: max,
				from: from,
				to: to
			}, { silent: true });
		},

		_validate: function(number, defaultValue, logLabel){
			var n = Number(number);
			if( Number.isNaN(n) ){
				if( number !== undefined && this.logger && this.logger.error ) {
					this.logger.error('RangeFilterModel invalid value ', logLabel , ' = ', number, 'using ', defaultValue, 'instead');
				}
				return defaultValue;
			}else{
				return n;
			}
		},

		update: function(from, to, inverted){
			this.set({
				from: from,
				to: to,
				inverted: inverted
			});
		},

		clearValues: function(){
			this.set({ from: this.min,
				to: this.max,
				inverted: false });
		},

		reset: function(min, max, from, to, inverted) {
			var modelChanged = this.max !== max ||
												this.min !== min ||
												this.to !== to ||
												this.from !== from ||
												this.inverted !== inverted;

			min = this._validate(min, 0, 'min');
			max = this._validate(max, 0, 'max');
			to = this._validate(to, max, 'to');
			from = this._validate(from, min, 'from');

			// Only trigger the reset when its necessary
			if (modelChanged) {
				this.set({
					min: min,
					max: max,
					to: to,
					from: from,
					inverted: inverted
				});
			}
		}
	});
	return RangeModel;
});
